import { AssessmentNomaRepository } from '../../infrastructure/assessment/AssessmentNomaRepository';

export const useCompleteVetAnalysis = (claimRequestKey: string) => {
    return {
        completeVetAnalysis: (note?: string) => {
            return AssessmentNomaRepository.completeVetAnalysis(claimRequestKey, note);
        },
    };
};
